import { createCrudSlice } from './createCrudSlice';
import { livingRoomsApi } from '../../services/api';

const { reducer, actions } = createCrudSlice('livingRooms', livingRoomsApi);

export const {
  fetchAll: fetchLivingRooms,
  fetchById: fetchLivingRoomById,
  create: createLivingRoom,
  update: updateLivingRoom,
  remove: deleteLivingRoom,
  clearError,
  clearCurrentItem,
} = actions;

export default reducer;
